module.exports = __webpack_public_path__ + "resource/img/image011Dark.66d36d74.png";